/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaModal/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import TysiaModalBackdrop from './TysiaModalBackdrop/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function TysiaModal({
  children,
  viewPath = "/DesignSystem/TysiaModal",
  top,
  onClose,
  closeOnClickOutside,
  minHeight,
  maxHeight = "calc(100vh - 32px)",
  height,
  maxWidth = "auto",
  width = 740,
  size
  
}) {
  let isMedia = useIsMedia()
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaModalBackdrop
  viewPath={`${viewPath}/TysiaModalBackdrop`}
 top={top}
 onClose={onClose}
 closeOnClickOutside={closeOnClickOutside}
>
{childProps => (
<div
  data-testid="TysiaModal.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-1kaJKF': dtColorsWhite,'--bblr-2-1kaJKF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-3-1kaJKF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-4-1kaJKF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-5-1kaJKF': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mh-6-1kaJKF': typeof minHeight === 'number' ? `${minHeight}px` : minHeight,'--mh-7-1kaJKF': typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight,'--mw-9-1kaJKF': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--w-10-1kaJKF': isMedia.mobile ? "95vw" : size === "fullscreen" ? "95vw" : size === "xlarge" ? "1024px" : size === "large" ? "740px" : size === "medium" ? "540px" : size === "small" ? "360px" : typeof width === 'number' ? `${width}px` : width,'--h-8-1kaJKF': size === "fullscreen" ? "95vh" : typeof height === 'number' ? `${height}px` : height}}
 className={`views-block TysiaModalShadow ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 onClose={onClose}
>
{children}
</Children>
</div>
)}
</TysiaModalBackdrop>
</React.Fragment>)
}